// @ts-nocheck
import React, { useState, useEffect, useMemo, useContext, useRef } from 'react';
import Breadcrumbs from '@/components/breadcrumbs';
import Search from '@/components/search';
import CellStatus from '@/components/cells/status-old';
import CellDate from '@/components/cells/date';
import CellBold from '@/components/cells/bold';
import ColumnSelect from '@/components/column-select';
import KendoPager from '@/components/kendo/kendo-pager';
import Fetch from '@/utils/Fetch';
import Storage from '@/utils/storage';
import * as Enums from '@/utils/enums';
import Helper from '@/utils/helper';
import DownloadService from '@/utils/download-service';
import FileService from '@/services/file-service';
import UCS from '@/services/option/user-config-service';
import KendoCellDate from '@/components/kendo/cells/kendo-cell-date';
import KendoCellStatus from '@/components/kendo/cells/kendo-cell-status';
import KendoTable from '@/components/kendo/kendo-table';
import PreviewAttachment from '@/components/modals/attachment/preview-attachment';
import { useRouter } from 'next/router';
import { createFileRoute } from '@tanstack/react-router'



function AttachmentList() {
  const router = useRouter();

  const [columnState, setColumnState] = useState<any[]>([]);
  const [availableColumns, setAvailableColumns] = useState<any[]>([]);
  const [requiredColumns, setRequiredColumns] = useState<any[]>([]);
  const [selectedColumns, setSelectedColumns] = useState<any[]>([]);

  const [filtersConfig, setFiltersConfig] = useState<any>(null);

  const columns = useMemo(
    () => columnState.filter((column: any) => column.Show == true).map(function (column: any) {
      let columnObject = {
        Header: column.Label,
        accessor: column.ColumnName,
        // for table resize columns
        ColumnName: column.ColumnName,
        UserWidth: column.UserWidth
        // for table resize columns
      }

      if (column.CellType != "none") {
        switch (column.CellType) {
          case 'date':
            columnObject['Cell'] = ({ cell: { value } }: any) => <CellDate value={value} />;
            columnObject['KendoCell'] = (props: any) => <KendoCellDate {...props} />;
            break;
          case 'status':
            columnObject['Cell'] = ({ cell: { value } }: any) => <CellStatus value={value} valueEnum={columnObject.accessor} />;
            columnObject['KendoCell'] = (props: any) => <KendoCellStatus {...props} valueEnum={columnObject.accessor} />
            break;
          default:
            columnObject['Cell'] = ({ cell: { value } }: any) => <CellBold value={value} />;
        }
      }

      return columnObject;
    }),
    [columnState]
  );

  function setColumn(selected: any) {
    let newColumns = [...selectedColumns];
    if (newColumns.includes(selected)) {
      newColumns = newColumns.filter((value: any) => { return value !== selected });
    } else {
      newColumns.push(selected);
    }
    setSelectedColumns(newColumns);

    const newState = columnState.map(function (column: any) {
      if (column.Label == selected) {
        column.Show = !column.Show;
      }
      return column;
    });
    setColumnState(newState);
    columnMappingPut(newState);
  }

  async function setReorder(updatedOptions: any) {

    const newState = updatedOptions.map((item: any, index: any) => {
      let column = columnState.find((x: any) => x.Label == item);
      column.Order = index;
      return column;
    });

    setAvailableColumns(updatedOptions);
    setColumnState(newState);

    columnMappingPut(newState);
  }

  async function columnMappingPut(newState: any) {
    await Fetch.put({
      url: '/Employee/ColumnMapping',
      params: {
        ColumnMappings: newState,
        model: 'AttachmentList',
      }
    });
  }

  // for table resize columns
  async function resetColumnWidths() {
    const newState = columnState.map(function (column: any) {
      column.UserWidth = null;
      return column;
    });
    setColumnState(newState);
    columnMappingPut(newState);
  }

  async function onColumnResize(columnName: any, width: any, columnNamesAndWidths: any) {
    const newState = columnState.map(function (column: any) {
      if (column.ColumnName === columnName) {
        column.UserWidth = width;
      } else if (columnNamesAndWidths) {
        let match = columnNamesAndWidths.find((x: any) => x.columnName === column.ColumnName);
        if (match) {
          column.UserWidth = match.width;
        }
      }
      return column;
    });
    setColumnState(newState);
    columnMappingPut(newState);
  }
  // for table resize columns

  const [attachmentResults, setAttachmentResults] = useState([{}]);
  const [sortField, setSortField] = useState('');
  const [sortDirection, setSortDirection] = useState('');
  const [searchVal, setSearchVal] = useState('');
  const [searching, setSearching] = useState(false);
  const [activeFilterIds, setActiveFilterIds] = useState<any>({});
  const [totalResults, setTotalResults] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  const [accessStatus, setAccessStatus] = useState(Enums.AccessStatus.None);

  const getAccessStatus = () => {
    let subscriptionInfo = Storage.getCookie(Enums.Cookie.subscriptionInfo);
    if (subscriptionInfo) {
      setAccessStatus(subscriptionInfo.AccessStatus);
    }
  };

  const [pageSize, setPageSize] = useState(10);

  const pageSizeChanged = (size: any) => {
    setPageSize(size);
  };

  const pageChanged = (page: any) => {
    setCurrentPage(page);
  };

  useEffect(() => {
    const init = async () => {
      const [filtersConfigResult, columnsResult] = await Promise.all([
        UCS.getPageFilters(Enums.ConfigurationSection.Attachment),
        Fetch.get({ url: '/Employee/ColumnMapping?model=AttachmentList' })
      ]);

      const [activeFilterIdsDefault, , sortExpressionDefault, sortDirectionDefault] = UCS.getFilterValues(
        filtersConfigResult, ["Modules", "AttachmentTypes"], []);

      const columns = columnsResult.Results;
      setColumnState(columns);
      setAvailableColumns(columns.map((c: any) => c.Label));
      setRequiredColumns(columns.filter((c: any) => c.IsRequired).map((c: any) => c.Label));
      setSelectedColumns(columns.filter((c: any) => c.Show).map((c: any) => c.Label));
      setFiltersConfig(filtersConfigResult);
      setSortField(sortExpressionDefault);
      setSortDirection(sortDirectionDefault);
      setActiveFilterIds(activeFilterIdsDefault);
      getAccessStatus();
    };
    init();
  }, []);

  useEffect(() => {
    if (accessStatus === Enums.AccessStatus.LockedWithOutAccess) {
      Helper.nextRouter(router.replace, "/");
    }
  }, [accessStatus]);

  const firstUpdate = useRef(true);

  useEffect(() => {
    if (firstUpdate.current) {
      firstUpdate.current = false;
      return;
    }

    if (currentPage == 1) {
      searchAttachments();
    } else {
      setCurrentPage(1);
    }
  }, [sortField, sortDirection, pageSize, activeFilterIds]);

  const firstUpdatePage = useRef(true);

  useEffect(() => {
    if (firstUpdatePage.current) {
      firstUpdatePage.current = false;
      return;
    }
    searchAttachments();
  }, [currentPage]);

  function setSort(field: any) {
    setSortDirection(Helper.getSortDirection(field, sortField, sortDirection));
    setSortField(field);
  }

  async function searchAttachments() {
    setSearching(true);

    const attachments = await Fetch.post({
      url: `/Attachment/GetAttachments`,
      params: {
        pageSize: pageSize,
        pageIndex: (currentPage - 1),
        searchPhrase: searchVal,
        sortExpression: sortField,
        sortDirection: sortDirection,
        ModuleList: activeFilterIds["Modules"],
        AttachmentTypeList: activeFilterIds["AttachmentTypes"],
      }
    });

    // filtersConfig code
    let filtersConfigTemp = { ...filtersConfig };
    UCS.updateFilters(filtersConfigTemp, activeFilterIds, null, sortField, sortDirection);
    UCS.saveConfigDebounced(filtersConfigTemp);
    setFiltersConfig(filtersConfigTemp);
    // filtersConfig code

    setAttachmentResults(attachments.Results);
    setTotalResults(attachments.TotalResults);
    setSearching(false);
  }

    const [showAttachmentPreview, setShowAttachmentPreview] = useState(false);
    const [attachmentToPreview, setAttachmentToPreview] = useState<any>();
    const [toggleAttachmentToPreview, setToggleAttachmentToPreview] = useState(false);

    const openInNewTab = async (attachment: any) => {
        let url = await Fetch.get({
            url: `/Attachment/AttachmentUrl?id=${attachment.ID}&download=${false}`
        });
        if (url) {
            window.open(url, "_blank");
        }
    };

    function rowClick(row: any) {
        let attachment = row.original;
        if (FileService.isPDF(attachment.FileName)) {
            openInNewTab(attachment);
        } else {            
            setAttachmentToPreview(attachment);            
            setToggleAttachmentToPreview(!toggleAttachmentToPreview);
        }
    }

    const previewAttachment = (attachment: any) => {
        if (FileService.isPDF(attachment.FileName)) {
            openInNewTab(attachment);
        } else {
            setAttachmentToPreview(attachment);   
            setShowAttachmentPreview(true);
        }
    };

    useEffect(() => {
        if (attachmentToPreview) {
            setShowAttachmentPreview(true);
        } else {
            setShowAttachmentPreview(false);
        }
    }, [toggleAttachmentToPreview]);

  const getTableActions = () => {
    let acts = [];

    acts.push({ text: "View", icon: "eye", function: previewAttachment, type: "Preview" });

    acts.push({ text: (downloading ? "Downloading" : "Download"), icon: "download", function: downloadFile });

    return acts;
  };

  const [downloading, setDownloading] = useState(false);
  const downloadFile = async (attachment: any) => {
    setDownloading(true);

    let filename = attachment.FileName;
    let dataUrl = attachment.Url;
    DownloadService.downloadURI(dataUrl, filename);

    setDownloading(false);
  }

  const filters = {
    Modules: Enums.getEnumItems(Enums.Module),
    AttachmentTypes: Enums.getAttachmentTypes(),
  };

  return (
    <div className="list-container">
      <div className="row">
        <div className="title">
          <Breadcrumbs crumbs={[
            { text: 'Attachments', link: '/attachment/list' },
            { text: 'Attachment List', link: '' }
          ]} />
        </div>
      </div>
      <div className="row end">
        <div className="search-container">
          <Search
            placeholder="Search description"
            resultsNum={attachmentResults.length}
            searchVal={searchVal}
            setSearchVal={setSearchVal}
            searchFunc={searchAttachments}
            filters={filters}
            setActiveFilterIds={setActiveFilterIds}
            filtersConfig={filtersConfig}
          />
        </div>
        <ColumnSelect options={availableColumns} selected={selectedColumns} requiredColumns={requiredColumns} setColumn={setColumn} setReorder={setReorder}
          resetColumnWidths={resetColumnWidths} />
      </div>
      <div className={"no-items" + (attachmentResults.length == 0 ? " no-items-visible" : "")}>
        <div className={"loading-overlay" + (searching ? " loading-overlay-visible" : "")}>
          <div className="loader"></div>
        </div>
        <img src="/job-folder.svg" alt="Attachment Folder" />
        <h3>No attachments found</h3>
        <p>If you can't find an attachment, try another search.</p>
        <img className="wave" src="/wave.svg" alt="wave" />
      </div>

      <div className="margin-top">
        {attachmentResults.length != 0 ? <KendoTable
          searching={searching}
          actions={getTableActions()}
          columns={columns}
          data={attachmentResults}
          rowClick={rowClick}
          setSort={setSort}
          sortField={sortField}
          sortDirection={sortDirection}
          type="Attachment"
          // for table resize columns
          onColumnResize={onColumnResize}
          // for table resize columns
          heightOffset={285}
          highlightColumnName="Description"
        /> : ""}
      </div>
      <KendoPager pageSizeChanged={pageSizeChanged} pageChanged={pageChanged} totalResults={totalResults} searchValue={searchVal}  parentPageNumber={currentPage}/>

      {showAttachmentPreview ?
          <PreviewAttachment attachment={attachmentToPreview} setShowAttachmentPreview={setShowAttachmentPreview} overlay={true} /> : ''
      }

      <style jsx>{`
        .column {
          width: 100%;
        }
        .column-margin {
          margin-left: 24px;
        }
        .button-container {
          flex-shrink: 0;
          width: 10rem;
        }
        .button-container :global(.button){
          margin-top: 0.5rem;
        }
        .margin-top {
          margin-top: 0.5rem;
        }
        .row {
          display: flex;
          justify-content: space-between;
        }
        .end {
          align-items: flex-end;
        }
        .row.top-gap {
          margin-top: 2.5rem;
        }
        .search-container :global(.search) {
          width: 528px;
        }
        a {
          text-decoration: none;
        }
      `}</style>
    </div>
  );
}

export default AttachmentList;

export const Route = createFileRoute('/_authenticated/attachment/list')({ component: AttachmentList })
